import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { BreakpointMobileUp, PathnamesMap } from '../constants/ui';
import { Header } from '../components/index.jsx';
import { useViewport } from '../hooks';
import { Gantt } from '../components/Gantt/index.jsx';
import { getSidebarLinksMap } from '../utils/ui';

const CropsPage = () => {
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  const navigate = useNavigate();
  const { widthViewport } = useViewport();

  useEffect(() => {
    if (widthViewport < BreakpointMobileUp) {
      navigate(`/${PathnamesMap.dashboard}`);
    }
  }, [widthViewport]);

  return (
    <>
      <Header title={SidebarLinksMap.crops.title} t={t} />
      <main className="main">
        <Gantt t={t} />
      </main>
    </>
  );
};

export default CropsPage;
